/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef, useRef } from 'react';
import {
  type ContextValue,
  type DatePickerProps as DatePickerCoreProps,
  type DateValue,
  DatePicker as DatePickerCore,
  Provider,
  useContextProps,
} from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { PopoverContext } from '../popover/popover.component';

interface DatePickerProps<T extends DateValue> extends Omit<DatePickerCoreProps<T>, 'className' | 'style'> {
  style?: stylex.StyleXStyles;
}

const DatePickerContext = createContext<ContextValue<DatePickerProps<DateValue>, HTMLInputElement>>({});

const DatePicker = forwardRef((props: DatePickerProps<DateValue>, ref: ForwardedRef<HTMLInputElement>) => {
  [props, ref] = useContextProps(props, ref, DatePickerContext);

  const { style, onBlur, onOpenChange, ...coreProps } = props;

  const isOpenRef = useRef(false);

  return (
    <Provider values={[
      [PopoverContext, {
        style: popoverStyles.base,
        shouldFlip: true
      }]
    ]}>
      <DatePickerCore
        ref={ref}
        {...stylex.props(style)}
        {...coreProps}
        onOpenChange={(isOpen) => {
          isOpenRef.current = isOpen;
          onOpenChange?.(isOpen);
          if (!isOpen) {
            onBlur?.(null!);
          }
        }}
        onBlur={(e) => {
          requestAnimationFrame(() => {
            if (!isOpenRef.current) {
              onBlur?.(e);
            }
          });
        }}
      />
    </Provider>
  );
}) as <T extends DateValue>(props: DatePickerProps<T> & { ref?: ForwardedRef<HTMLInputElement> }) => ReactElement;

const popoverStyles = stylex.create({
  base: {
    padding: 8,
    borderColor: $.border06,
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    outline: 'none',
    overflow: 'auto',
    backgroundColor: $.surfaceBGPrimary,
    boxShadow: $.shadowCenter050Medium,
    boxSizing: 'border-box',
    maxHeight: 'inherit',
  },
});

export { DatePicker, DatePickerContext, type DatePickerProps };
